export default {
    term: "",
    searching: false,
    results: [],
    search_type: "suppliers",
    has_other_data: false,
    curpage: 1,
};
